import { FaturaAnaSayfaPage } from './../fatura-ana-sayfa/fatura-ana-sayfa';
import { BllSiparisDetay } from './../../../providers/bll/bll-siparis-detay';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';



@Component({
  selector: 'page-faturaonayla',
  templateUrl: 'faturaonayla.html',
})
export class FaturaonaylaPage {
  gidecekFaturaOzellik: any = { CariID: "", ToplamTutar: "", Method: "" };
  faturaJson: any = { Aciklama: "", FaturaTarih: "", VadeTarih: "", CariID: "", ToplamTutar: "", Method: "" }
  aktifkullaniciadi = "";
  stoktandussunmu:number=1;
  evethayir=[];
  sipID:number=0;
  suankitarih: any;
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {
    if (navParams.get("Fatura") != null) {
      this.gidecekFaturaOzellik = navParams.get("Fatura");

      this.faturaJson.CariID = this.gidecekFaturaOzellik.CariID;
      this.faturaJson.ToplamTutar = this.gidecekFaturaOzellik.ToplamTutar;
      this.faturaJson.Method = this.gidecekFaturaOzellik.Method;
      if(this.faturaJson.Method=="SatisFatKaydet")
      {
        this.sipID=-995;
      }
      if(this.faturaJson.Method=="AlisFatKaydet")
      {
        this.sipID=-994;
      }

    }
    this.aktifkullaniciadi = this.ortak.storagePersonelGetir.Name;
    this.suankitarih = new Date().toUTCString();
    this.suankitarih = this.ortak.tarih(this.suankitarih);
    this.faturaJson.FaturaTarih = new Date().toISOString();
    this.faturaJson.VadeTarih = this.suankitarih;
    this.evethayir = [{
      "ID": "0",
      "Adi": "Hayır"
    },
    {
      "ID": "1",
      "Adi": "Evet"
    }
    ];
  }

  Onayla() {
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.getAll({ siparisID: this.sipID }).then(a => {
      var formData = new FormData();
      this.faturaJson.ToplamTutar = this.faturaJson.ToplamTutar.toFixed(2);
      formData.append("stokhareket", JSON.stringify(a));
      formData.append("cariid", this.faturaJson.CariID.toString());
      formData.append("faturatutar", this.faturaJson.ToplamTutar.toString());
      formData.append("islemiyapan", this.aktifkullaniciadi.toString());
      formData.append("faturaaciklama", this.faturaJson.Aciklama.toString());
      formData.append("vadetarihi", this.ortak.tarih(this.faturaJson.VadeTarihi));
      formData.append("faturatarih", this.ortak.tarih(this.faturaJson.FaturaTarih));
      if(this.faturaJson.Method=="SatisFatKaydet")
      {
        formData.append("stokdussunmu",this.stoktandussunmu.toString());
      }
    
      this.bllOrtak.islem(formData, this.faturaJson.Method, "Fatura kaydediliyor lütfen bekleyiniz..", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Uyarı", "Fatura Başarılı Bir Şekilde EKlenmiştir");
        bllSiparisDetay.execRawQuery("DELETE FROM NL_Siparis WHERE siparisID = " + this.sipID).then(b => {
          this.navCtrl.setRoot(FaturaAnaSayfaPage);
        })
      })
    });
  }
  kapat() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/faturaonayla/faturaonayla.ts